export default "__VITE_ASSET__B3drfm_L__"